import { SortOrder } from '../search/sort-order/sort-order.enum';

function getValue<T>(item: T, property: keyof T) {
  const blankValues = ['undefined', 'null'];
  const value = item[property];

  if (blankValues.some((blank) => typeof value === blank)) {
    return Infinity;
  }

  return value;
}

const SORT_METHODS = {
  [SortOrder.ASC]: (a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;

    return 0;
  },
  [SortOrder.DESC]: (a, b) => {
    if (a > b) return -1;
    if (a < b) return 1;

    return 0;
  },
};

export function sortBy<T>(
  array: T[],
  property: keyof T,
  order: SortOrder = SortOrder.ASC,
): T[] {
  return array.sort((a, b) => {
    const aValue = getValue<T>(a, property);
    const bValue = getValue<T>(b, property);

    return SORT_METHODS[order](aValue, bValue);
  });
}
